export enum BookingStepMode {
    SELF_NEW_BOOKING,
    SELF_VIEW_BOOKING,
    ADMIN_NEW_BOOKING,
    ADMIN_NEW_BOOKING_FOR_CUSTOMER,
    ADMIN_VIEW_BOOKING,
    ADMIN_VIEW_RESERVATION
}
